"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OffscreenLocationSelector = exports.ScreenLocationSelector = exports.ActorGridLocationSelector = exports.FactionOpenCellLocationSelector = exports.FactionGridLocationSelector = exports.ActorVicinityLocationSelector = exports.ActorVfxLocationSelector = void 0;
class ActorVfxLocationSelector {
    constructor(actorId, attachment = "chest", positionZ = "front") {
        this.actorId = actorId;
        this.attachment = attachment;
        this.positionZ = positionZ;
        this.__typeName = "Actor";
    }
    movingForAbility(abilityKey) {
        this.positionForAbility = abilityKey;
        return this;
    }
}
exports.ActorVfxLocationSelector = ActorVfxLocationSelector;
ActorVfxLocationSelector.Miss = (actorId) => new ActorVfxLocationSelector(actorId, "random", "behind");
class ActorVicinityLocationSelector {
    constructor(actorId, positionX = "center", positionY = "center", positionZ = "front") {
        this.actorId = actorId;
        this.positionX = positionX;
        this.positionY = positionY;
        this.positionZ = positionZ;
        this.__typeName = "ActorVicinity";
    }
}
exports.ActorVicinityLocationSelector = ActorVicinityLocationSelector;
class FactionGridLocationSelector {
    constructor(faction, positionX, positionY) {
        this.faction = faction;
        this.positionX = positionX;
        this.positionY = positionY;
        this.__typeName = "FactionGrid";
    }
}
exports.FactionGridLocationSelector = FactionGridLocationSelector;
FactionGridLocationSelector.CenterOf = (faction) => new FactionGridLocationSelector(faction, "center", "center");
class FactionOpenCellLocationSelector {
    constructor(faction) {
        this.faction = faction;
        this.__typeName = "FactionOpenCell";
    }
}
exports.FactionOpenCellLocationSelector = FactionOpenCellLocationSelector;
class ActorGridLocationSelector {
    constructor(actorId) {
        this.actorId = actorId;
        this.__typeName = "ActorGrid";
    }
}
exports.ActorGridLocationSelector = ActorGridLocationSelector;
class ScreenLocationSelector {
    constructor(positionX, positionY) {
        this.positionX = positionX;
        this.positionY = positionY;
        this.__typeName = "Screen";
    }
}
exports.ScreenLocationSelector = ScreenLocationSelector;
ScreenLocationSelector.Center = () => new ScreenLocationSelector("center", "center");
class OffscreenLocationSelector {
    constructor(actorId, positionX) {
        this.actorId = actorId;
        this.positionX = positionX;
        this.__typeName = "Offscreen";
    }
}
exports.OffscreenLocationSelector = OffscreenLocationSelector;
